import { apiClient } from '@indipia/shared';
import { SHARE_LOAD_TIMEOUT_MS } from '@indipia/shared-features';
import type { DeliveryPayload } from '../pages/share/vendorDelivery.logic';
import { PHOTO_UPLOAD_TIMEOUT_MS } from '../pages/share/vendorDelivery.logic';
import { listEntryParams, withListEntry } from './orderListShareApi';

// C-4-1 거래처 배송정보 등록 — Planner B3~B7b (외부 공유쿠키, shareId는 경로·본문·쿼리에 싣지 않음: F-04 §9).
// 받은 발주 목록에서 들어온 화면이면 쿼리 orderVendorId 를 모든 호출에 붙인다(listEntryParams, E-15·E-12).
// 쓰기 호출은 자동 재시도하지 않음.
const BASE = '/schedule/order-shares/me';

interface Envelope<T> {
  data: T;
}

export const orderDeliveryShareApi = {
  /** B3 배송정보 화면 조회 */
  async get(signal?: AbortSignal): Promise<unknown> {
    const res = await apiClient.get<Envelope<unknown>>(`${BASE}/delivery`, {
      params: listEntryParams(),
      signal,
      timeout: SHARE_LOAD_TIMEOUT_MS,
    });
    return res.data?.data;
  },

  /** B4 첫 제출(201) */
  async create(body: DeliveryPayload): Promise<unknown> {
    const res = await apiClient.post<Envelope<unknown>>(`${BASE}/deliveries`, body, { params: listEntryParams() });
    return res.data?.data;
  },

  /** B5 도착 전 수정(전체 교체, 200) */
  async update(body: DeliveryPayload): Promise<unknown> {
    const res = await apiClient.put<Envelope<unknown>>(`${BASE}/deliveries`, body, { params: listEntryParams() });
    return res.data?.data;
  },

  /** B6 상차사진 1장 업로드(multipart `files`, 201). Content-Type 직접 지정 금지(boundary). */
  async uploadPhoto(file: File, onProgress?: (pct: number) => void): Promise<unknown> {
    const form = new FormData();
    form.append('files', file);
    const res = await apiClient.post<Envelope<unknown>>(`${BASE}/delivery-photos`, form, {
      params: listEntryParams(),
      timeout: PHOTO_UPLOAD_TIMEOUT_MS,
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
    return res.data?.data;
  },

  /** B7 상차사진 삭제(204) */
  async deletePhoto(orderPhotoId: number): Promise<void> {
    await apiClient.delete(`${BASE}/delivery-photos/${orderPhotoId}`, { params: listEntryParams() });
  },

  /** B7b 이미지 경로(guestFileUrl 입력용) */
  photoPath(orderPhotoId: number, size: 'thumb' | 'original'): string {
    return withListEntry(`${BASE}/delivery-photos/${orderPhotoId}?size=${size}`);
  },
};
